import React from "react";

export default function NotificationVideo({ videoUrl }) {
  const videoCode = () => {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = videoUrl.match(regExp);
    if (match && match[2].length === 11) {
      return match[2];
    } else {
      return null;
    }
  };

  return (
    <div className="notification-video-container">
      <iframe
        className="notification-video-iframe"
        src={`https://www.youtube.com/embed/${videoCode()}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture"
        title="Embedded youtube"
      />
    </div>
  );
}
